export default {
  PBTF: 'pbtf',
  MULTI_IMAGE: 'multimage'
} as const;
